// =========================================
// firebase/functions.js — chiamata alle Cloud Functions HTTPS
// =========================================
//
// Helper per invocare le funzioni onRequest (resetTenantData, deleteAccount,
// submitSupportTicketTracker) passando l'ID token dell'utente autenticato.
// La funzione lo verifica con l'Admin SDK ed esegue l'operazione lato server.
//
// URL:
//   • default:    https://<region>-<projectId>.cloudfunctions.net/<name>
//   • emulatori:  http://127.0.0.1:5001/<projectId>/<region>/<name>
//   • override:   GATSBY_FUNCTIONS_BASE_URL (es. dominio hosting con rewrite /api)

import { auth } from './config';

const REGION = 'europe-west1';
const PROJECT_ID = process.env.GATSBY_FIREBASE_PROJECT_ID;
const USE_EMULATORS = process.env.GATSBY_FIREBASE_USE_EMULATORS === 'true';
const BASE_OVERRIDE = process.env.GATSBY_FUNCTIONS_BASE_URL || '';

function functionUrl(name) {
  if (BASE_OVERRIDE) return `${BASE_OVERRIDE.replace(/\/$/, '')}/${name}`;
  if (USE_EMULATORS) return `http://127.0.0.1:5001/${PROJECT_ID}/${REGION}/${name}`;
  return `https://${REGION}-${PROJECT_ID}.cloudfunctions.net/${name}`;
}

// Invoca una Cloud Function HTTPS. Ritorna il JSON di risposta; lancia in errore
// (con il messaggio della funzione, se presente) su risposta non-2xx.
export async function callFunction(name, body = {}) {
  const a = auth();
  const user = a?.currentUser;
  if (!user) throw new Error('Non autenticato');
  const token = await user.getIdToken();

  const res = await fetch(functionUrl(name), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body || {}),
  });

  let data = null;
  try { data = await res.json(); } catch { /* corpo non-JSON */ }
  if (!res.ok) throw new Error(data?.error || `Errore funzione ${name} (${res.status})`);
  return data;
}
